import React from "react";
import Select from "react-select";

const ratingOptions = [1, 2, 3, 4].map((v) => ({ label: `L${v}`, value: v }));
const tickOptions = [
    { label: "1 Tick", value: 1 },
    { label: "2 Ticks", value: 2 },
    { label: "3 Ticks", value: 3 },
    { label: "4 Ticks", value: 4 },
];

const AdditionalFieldInput = ({ field, value, invalid, isLocked, onChange, onBlur }) => {
    if (field.isTextBox) {
        return (
            <>
                <input
                    type="text"
                    className="common-input"
                    placeholder="Textbox"
                    style={invalid ? { borderColor: "red" } : {}}
                    value={value || ""}
                    onChange={(e) => onChange(e.target.value)}
                    required={field.isRequired}
                    onBlur={onBlur}
                    disabled={isLocked}
                />
                {invalid && (
                    <span style={{ color: "red", fontSize: "12px", display: "block" }}>
                        This field is required
                    </span>
                )}
            </>
        );
    }

    if (field.isRating || field.isTickRating) {
        const options = field.isRating ? ratingOptions : tickOptions;
        return (
            <>
                <Select
                    options={options}
                    className="evalutionselect"
                    value={options.find((o) => o.value === Number(value)) || null}
                    onChange={(val) => onChange(val.value)}
                    onBlur={onBlur}
                    isDisabled={isLocked}
                />
                {invalid && (
                    <span style={{ color: "red", fontSize: "12px", display: "block" }}>
                        Please select an option
                    </span>
                )}
            </>
        );
    }

    return null;
};

export default AdditionalFieldInput;